import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { GetEntityConnectionGQL, GetEntityConnectionQuery } from 'generated/graphql';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-entity-connection-lazy-content',
  templateUrl: './entity-connection-lazy-content.component.html',
  ///styleUrls: ['./entity-connection-lazy-content.component.scss']
})
export class EntityConnectionLazyContentComponent extends WithDisposableSubject() implements OnInit {
  loading = true;

  @Input() campaignId: string;
  @Input() entityConnectionId: string;

  entityConnection: GetEntityConnectionQuery['getEntityConnection'];

  constructor(
    private _cd: ChangeDetectorRef,
    private _getEntityConnectionGQL: GetEntityConnectionGQL
  ) {
    super();
  }

  ngOnInit(): void {
    this._getEntityConnectionGQL.watch({
      entityConnectionId: this.entityConnectionId,
      campaignId: this.campaignId
    })
      .valueChanges
      .pipe(
        takeUntil(this.disposer)
      )
      .subscribe(({ data }) => {
        this.entityConnection = data.getEntityConnection;
        this.loading = false;
        this._cd.markForCheck();
      });

  }
}
